document.addEventListener('DOMContentLoaded', () => {
  // Select product card buttons
  const buttons = document.querySelectorAll('.product-grid-item__actions__btn, button.cart--icon-button');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Add a "clicked" state
      btn.classList.add('clicked');
      btn.querySelector('.action__btn--text--label').innerHTML= "Added To Cart";
    });
  });

  // You could later add more product-card specific JS here
  // like quick-view toggles, wishlist buttons, etc.
});
